export default {
  name: 'huaihua',
  adcode: '431200',
  mapName: '怀化市',
  geoJsonPath: 'hunanmap/431200.json',
  backgroundImage: {
    png: '怀化市_431200.png',
    webp: '怀化市_431200.webp'
  },
  echartsMapStyle: {
    width: '817px',
    height: '720px',
    marginTop: 'auto',
    marginBottom: '42px',
  },
  imageSize: {
    width: 3772,
    height: 3324
  },
  // 地图特殊配置：背景图片适配参数
  specialConfig: {
    // 独立调整参数
    layoutSizeAdjustment: {
      enabled: true,
      multiplier: 1.135, // 布局尺寸调整倍数（微调）
      minSize: 400,     // 最小布局尺寸
      maxSize: 1200     // 最大布局尺寸
    },
    aspectScaleAdjustment: {
      enabled: true,
      multiplier: 1, // 宽高比调整倍数（微调）
      minScale: 0.5,    // 最小缩放比例
      maxScale: 2.0     // 最大缩放比例
    },
    // 位置偏移补偿
    positionOffset: {
      x: 0.001,  // X轴偏移百分比
      y: 0.001  // Y轴偏移百分比
    }
  },
  // 区县列表（怀化市）
  districts: [
    '怀化市区',
    '沅陵县',
    '辰溪县',
    '溆浦县',
    '会同县',
    '麻阳苗族自治县',
    '新晃侗族自治县',
    '芷江侗族自治县',
    '靖州苗族侗族自治县',
    '通道侗族自治县',
    '洪江市'
  ],
  // 区县坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    // 市区参考坐标（用于兜底展示）
    '怀化市区': [109.982242, 27.498474],
    '怀化市': [109.982242, 27.548474],
    '沅陵县': [110.939161, 28.135554],
    '辰溪县': [110.274953, 27.725474],
    '溆浦县': [110.663373, 27.475802],
    '会同县': [109.440785, 27.100789],
    '麻阳苗族自治县': [109.802807, 27.865991],
    '新晃侗族自治县': [109.094443, 27.729897],
    '芷江侗族自治县': [109.557777, 27.647996],
    '靖州苗族侗族自治县': [109.041159, 26.893511],
    '通道侗族自治县': [109.061159, 26.573511],
    '洪江市': [109.898765, 27.211876]
  },
  // 区县名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    if (s === '怀化市') return '怀化市区'
    return s
  },
  // 区县与adcode映射（怀化市）
  cityAdcodeMap: {
    '鹤城区': '431202',
    '中方县': '431221',
    '沅陵县': '431222',
    '辰溪县': '431223',
    '溆浦县': '431224',
    '会同县': '431225',
    '麻阳苗族自治县': '431226',
    '新晃侗族自治县': '431227',
    '芷江侗族自治县': '431228',
    '靖州苗族侗族自治县': '431229',
    '通道侗族自治县': '431230',
    '洪江市': '431281'
  }
}